module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu72xKOzY.4743c758.woff2";